import React from 'react';
import clsx from 'clsx';
import CtaButton from '@/components/shared/ctaButton/CtaButton';
import Sunrise from '@/components/shared/sunrise/Sunrise';

const SmallHeroSlide = ({ heroSlide }) => {
  const { overrideColorScheme, ctaButton, secondCtaButton } = heroSlide;
  const colorScheme = heroSlide.colorScheme.toLowerCase();

  const slideStyles = {
    backgroundColor: heroSlide.backgroundColor,
    color: heroSlide.textColor
  };

  return (
    <div
      className={clsx('color-wrapper', {
        [colorScheme]: !overrideColorScheme,
        gradient: heroSlide.hasSunrise
      })}
      style={overrideColorScheme ? slideStyles : null}
    >
      <div className="content">
        <div className="container-fluid">
          {heroSlide.hasSunrise && colorScheme !== 'white' && colorScheme !== 'offset' && (
            <Sunrise />
          )}
          <div className="inner-content">
            <p
              className="eyebrow-text"
              dangerouslySetInnerHTML={{ __html: heroSlide.eyebrowText }}
            />
            <h1>
              <span dangerouslySetInnerHTML={{ __html: heroSlide.title }} />
            </h1>
          </div>
          {ctaButton.hasCtaButton && (
            <div className="inner-cta button">
              <CtaButton {...ctaButton} />
              <CtaButton {...secondCtaButton} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SmallHeroSlide;
